export default __webpack_public_path__ + "static/media/rms_mobile.78f48175.jpg";